import { render, staticRenderFns } from "./PendingIncome.vue?vue&type=template&id=6e777349&scoped=true&lang=pug&"
import script from "./PendingIncome.vue?vue&type=script&lang=js&"
export * from "./PendingIncome.vue?vue&type=script&lang=js&"
import style0 from "./PendingIncome.vue?vue&type=style&index=0&id=6e777349&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e777349",
  null
  
)

export default component.exports